module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/share-refer-9890e82e3206183c2c8d1d690dbb9e8d.png";